module.exports = __webpack_public_path__ + "img/2018-04-30.e9b21c9b.jpg";